import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from "flarum/forum/app";
import Modal from "flarum/common/components/Modal";
import humanTime from "flarum/common/helpers/humanTime";
import { RevisionsSkeleton } from "./Skeletons";
/**
 * A message's edit history.
 *
 * Each row is the text *before* one edit, oldest first, with the current content
 * last so the list reads as a chronology rather than as a pile of diffs. Plain text
 * throughout: a revision is a record of what was written, and re-rendering old
 * markup would let a since-removed mention or embed fire again.
 */
export default class RevisionsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "revisions", []);
    _defineProperty(this, "loadingRevisions", true);
    _defineProperty(this, "failed", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  className() {
    return "ChatModal ChatRevisions Modal--medium";
  }
  title() {
    return app.translator.trans("ramon-chat.forum.revisions.title");
  }
  content() {
    var _this$attrs$message$c;
    if (this.loadingRevisions) {
      return m("div", {
        className: "Modal-body"
      }, RevisionsSkeleton());
    }
    if (this.failed) {
      return m("div", {
        className: "Modal-body"
      }, m("div", {
        className: "ChatBrowse-empty"
      }, app.translator.trans("ramon-chat.forum.revisions.failed")));
    }
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "ChatRevisions-list"
    }, this.revisions.map(revision => {
      var _revision$editedBy$di, _revision$editedBy, _revision$content;
      return m("div", {
        className: "ChatRevisions-entry",
        key: revision.id
      }, m("div", {
        className: "ChatRevisions-meta"
      }, m("span", {
        className: "ChatRevisions-author"
      }, (_revision$editedBy$di = (_revision$editedBy = revision.editedBy) == null ? void 0 : _revision$editedBy.displayName) != null ? _revision$editedBy$di : app.translator.trans("ramon-chat.forum.revisions.unknown_editor")), revision.createdAt ? m("span", null, humanTime(new Date(revision.createdAt))) : null), m("div", {
        className: "ChatRevisions-content"
      }, (_revision$content = revision.content) != null ? _revision$content : ""));
    }), m("div", {
      className: "ChatRevisions-entry ChatRevisions-entry--current"
    }, m("div", {
      className: "ChatRevisions-meta"
    }, m("span", {
      className: "ChatRevisions-author"
    }, app.translator.trans("ramon-chat.forum.revisions.current"))), m("div", {
      className: "ChatRevisions-content"
    }, (_this$attrs$message$c = this.attrs.message.content()) != null ? _this$attrs$message$c : ""))));
  }
  async load() {
    try {
      var _payload$data$attribu, _payload$data;
      const payload = await app.request({
        method: "GET",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-messages/").concat(this.attrs.message.id(), "/revisions")
      });
      this.revisions = (_payload$data$attribu = (_payload$data = payload.data) == null || (_payload$data = _payload$data.attributes) == null ? void 0 : _payload$data.revisions) != null ? _payload$data$attribu : [];
    } catch (_unused) {
      this.failed = true;
    } finally {
      this.loadingRevisions = false;
      m.redraw();
    }
  }
}
flarum.reg.add('ramon-chat', 'forum/components/RevisionsModal', RevisionsModal);